var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 2.5C10.8359 2.5 3 10.3359 3 20C3 29.6641 10.8359 37.5 20.5 37.5C30.1641 37.5 38 29.6641 38 20C38 10.3359 30.1641 2.5 20.5 2.5ZM20.5 34.5312C12.4766 34.5312 5.96875 28.0234 5.96875 20C5.96875 11.9766 12.4766 5.46875 20.5 5.46875C28.5234 5.46875 35.0312 11.9766 35.0312 20C35.0312 28.0234 28.5234 34.5312 20.5 34.5312Z",
    fill: "#2A9D8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0342 11.0967L28.6006 19.4952C28.6805 19.5527 28.7455 19.6284 28.7903 19.716C28.8352 19.8036 28.8586 19.9006 28.8586 19.9991C28.8586 20.0975 28.8352 20.1945 28.7903 20.2821C28.7455 20.3697 28.6805 20.4454 28.6006 20.503L17.0342 28.9014C16.624 29.1983 16.0459 28.9092 16.0459 28.3975V11.6006C16.0454 11.4856 16.0768 11.3727 16.1366 11.2745C16.1964 11.1763 16.2824 11.0966 16.3849 11.0443C16.4873 10.9921 16.6023 10.9693 16.7169 10.9786C16.8316 10.9878 16.9414 11.0287 17.0342 11.0967Z",
    fill: "#2A9D8C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.a69abb811e294c521c4daaf46427df3d.svg";
export { ForwardRef as ReactComponent };